<ion-menu (ionWillOpen)="ionOpen()" contentId="main-content" type="overlay" side="end">
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-menu-toggle>
          <ion-button>
            <ion-icon
              aria-hidden="false"
              class="material-icons"
              slot="icon-only"
              name="close-outline"
            ></ion-icon>
            <span class="sr-only">{{ 'go-back-button' | translate }}</span>
          </ion-button>
        </ion-menu-toggle>
      </ion-buttons>
      <ion-title>{{ appInstanceName }}</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list id="inbox-list">
      <ion-menu-toggle auto-hide="false" *ngFor="let p of sectionPages('primary'); let i = index">
        <ion-item
          button
          routerDirection="root"
          (click)="navigateToPage(p.url)"
          lines="none"
          detail="false"
          routerLinkActive="selected"
        >
          <span aria-hidden="true" class="material-icons" slot="start">{{ p.icon }}</span>
          <ion-label>{{ p.title | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <ion-item-divider></ion-item-divider>

      <ion-menu-toggle auto-hide="false" *ngFor="let p of sectionPages('secondary'); let i = index">
        <ion-item
          button
          routerDirection="root"
          (click)="p.external ? navigateToExternal(p.url) : navigateToRootPage(p.url)"
          lines="none"
          detail="false"
          routerLinkActive="selected"
        >
          <ion-label>{{ p.title | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <ion-item-divider></ion-item-divider>

      <ion-list>
        <ion-list-header mode="md">
          <ion-label>{{ 'sideMenu.items.area' | translate }}</ion-label>
        </ion-list-header>
        <ion-menu-toggle>
          <ion-item lines="none">
            <div class="button-wrapper">
              <button
                class="organization-button"
                routerDirection="root"
                (click)="navigateToAreaSelector()"
                routerLinkActive="selected"
              >
                <div class="logo">
                  <img [src]="logoUrl" alt="" aria-hidden="true" />
                </div>

                <div
                  class="details"
                  *ngIf="
                    selectedOrganization &&
                    selectedOrganization.name &&
                    selectedOrganization.name.length > 0
                  "
                >
                  <p class="name">
                    <span> {{ selectedOrganization.name }} </span>
                  </p>
                  <p class="address">
                    <span *ngIf="organizationDetails && organizationDetails.length > 0">
                      {{ organizationDetails }}
                    </span>
                  </p>
                </div>

                <div class="icon">
                  <span class="material-icons" aria-hidden="true"> sync_alt </span>
                </div>
              </button>
            </div>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

      <ion-item-divider></ion-item-divider>

      <ion-list>
        <ion-item lines="none">
          <ion-label>{{ 'sideMenu.items.language' | translate }}</ion-label>
          <ion-select
            [value]="currentLanguage"
            okText="{{ 'profile.save' | translate }}"
            cancelText="{{ 'profile.cancel' | translate }}"
            (ionChange)="changeAppLanguage($event)"
          >
            <ion-select-option *ngFor="let lang of languages" value="{{ lang }}">
              {{ lang + '-language' | translate }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item class="font-changer" lines="none">
          <ion-label>{{ 'sideMenu.items.fontsize' | translate }}</ion-label>
          <ion-button (click)="DecreaseFontSize()"
            ><ion-icon slot="icon-only" name="remove"></ion-icon
            ><span class="sr-only">{{ 'sideMenu.items.decrease' | translate }}</span></ion-button
          >
          <ion-button (click)="IncreaseFontSize()"
            ><ion-icon slot="icon-only" name="add"></ion-icon
            ><span class="sr-only">{{ 'sideMenu.items.increase' | translate }}</span></ion-button
          >
        </ion-item>

        <ion-menu-toggle
          auto-hide="false"
          *ngFor="let p of sectionPages('tertiary'); let i = index"
        >
          <ion-item
            button
            routerDirection="root"
            (click)="p.external ? navigateToExternal(p.url) : navigateToRootPage(p.url)"
            lines="none"
            detail="false"
            routerLinkActive="selected"
          >
            <ion-label>{{ p.title | translate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-list>
  </ion-content>
</ion-menu>
